import { CrossSellingRequestType } from "./cross-selling-request-type.enum";

export default abstract class CrossSellingRequest {
  public type: CrossSellingRequestType;
  public pageable: any;
}
